import { COLORS, ColorName } from '../constants/colors';
import { LanguageCodes } from '../constants/languages';
import { Scenes } from '../constants/scenes';
import { GameState } from '../types/game-state';

/**
 * Extract the game state from the raw query parameters.
 *
 * **note** how the query params are usually the value but aren't perfect
 * is pretty annoying, also why I dislike enums
 *
 * @param rawQueryParams the raw query-params passed into the page
 */
export function getGameStateFromCheats(
  rawQueryParams: Record<string, string>,
): Partial<GameState> & { scene?: Scenes } {
  const gameState: Partial<GameState> & { scene?: Scenes } = {};

  // Extract player color if it exists
  if (
    rawQueryParams.playerColor &&
    COLORS.includes(rawQueryParams.playerColor.toUpperCase() as ColorName)
  ) {
    gameState.playerColor = rawQueryParams.playerColor.toUpperCase() as GameState['playerColor'];
  }

  // Extract player known language if it exists
  if (
    rawQueryParams.playerKnownLanguage &&
    Object.keys(LanguageCodes).includes(rawQueryParams.playerKnownLanguage)
  ) {
    gameState.playerKnownLanguage = LanguageCodes[rawQueryParams.playerKnownLanguage];
  }

  // Extract scenes if they exist
  if (rawQueryParams.scene && Object.values(Scenes).includes(rawQueryParams.scene as Scenes)) {
    gameState.scene = Scenes[rawQueryParams.scene.toUpperCase() as keyof typeof Scenes];
  }

  return gameState;
}
